import React, { useEffect, useState } from "react";
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Hero from "../components/Hero";
import Section from "../components/Section";
import Download from "../components/Download";
import { useSelector } from "react-redux";

export default function LandingPage(props) {
  const auth = useSelector((state) => state.auth);
  const [role, setRole] = useState();
  useEffect(() => { if (auth && auth.profile && auth.profile.uid) setRole(auth.profile.usertype); }, [auth]);
  return (
    <div style={{ backgroundColor: "#FFFFFF", margin: "-8px", overflowX: "hidden" }}>
      <Header color="transparent" routes={[]} rightLinks={<HeaderLinks />} fixed changeColorOnScroll={{ height: 80, color: "white" }} {...props} />
      <Hero role={role} />
      <Section role={role} />
      <Download />
      <HomeFooter />
    </div>
  );
}
